// import React from 'react';
// import { X, Building, MapPin, DollarSign, Users } from "lucide-react";

// const CareerViewModal = ({ career, onClose, onClick }) => {
//   if (!career) return null;

//   console.log("career ", career);

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
//         <div className="sticky top-0 bg-gradient-to-r from-[#0bb6d9] to-[#3cd7f6] text-white p-6 flex justify-between items-center rounded-t-2xl shadow-md">
//           <h2 className="text-2xl font-bold">Career Details</h2>
//           <button
//             onClick={onClose}
//             className="hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition"
//           >
//             <X className="w-6 h-6" />
//           </button>
//         </div>

//         <div className="p-6 space-y-6">
//           {/* Basic Information */}
//           <div className="bg-gray-50 rounded-lg p-6 space-y-6">
//             <label className="text-lg font-semibold text-gray-800 flex items-center mb-2">
//               <Building className="w-5 h-5 text-[#0bb6d9] mr-2" />
//               Basic Information
//             </label>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Position</label>
//                 <p className="text-xl font-bold text-gray-900 bg-white p-3 rounded-lg shadow-sm">{career.position}</p>
//               </div>
//               {/* <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Job Type</label>
//                 <p className="text-lg text-gray-900 bg-white p-3 rounded-lg shadow-sm capitalize">{career.jobType}</p>
//               </div> */}
//               <div>
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Job Openings</label>
//                 <p className="text-lg text-gray-900 bg-white p-3 rounded-lg shadow-sm capitalize">{career.jobDetail.jobOpenings}</p>
//               </div>
//             </div>
//           </div>

//           {/* Company Information */}
//           <div className="bg-blue-50 rounded-lg p-6 space-y-6">
//             <label className="text-lg font-semibold text-gray-800 flex items-center mb-2">
//               <Building className="w-5 h-5 text-blue-600 mr-2" />
//               Company Information
//             </label>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {career.company.companyLogo && (
//                 <div className="flex flex-col items-center bg-white p-4 rounded-lg shadow-sm">
//                   <img
//                     src={career.company.companyLogo}
//                     alt={career.company.companyName}
//                     className="w-24 h-24 rounded-full object-cover mb-3 border-4 border-blue-100"
//                   />
//                   <p className="text-center font-bold text-gray-900 text-lg">{career.company.companyName}</p>
//                 </div>
//               )}

//               <div className="bg-white p-4 rounded-lg shadow-sm">
//                 <label className="text-sm font-semibold text-gray-700 mb-2 flex items-center">
//                   <MapPin className="w-4 h-4 mr-1" />
//                   Location
//                 </label>
//                 <p className="text-gray-900">{career.company.jobLocation}</p>
//               </div>
//             </div>
//           </div>

//           {/* Job Details */}
//           {/* <div className="bg-green-50 rounded-lg p-6 space-y-6">
//             <label className="text-lg font-semibold text-gray-800 flex items-center mb-2">
//               <DollarSign className="w-5 h-5 text-green-600 mr-2" />
//               Job Details
//             </label>

//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//               <div className="bg-white p-4 rounded-lg shadow-sm">
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Salary</label>
//                 <p className="text-lg font-semibold text-gray-900">{career.jobDetail.salary}</p>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow-sm">
//                 <label className="block text-sm font-semibold text-gray-700 mb-2">Currency</label>
//                 <p className="text-lg text-gray-900">{career.jobDetail.salaryCurrency}</p>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow-sm">
//                 <label className="text-sm font-semibold text-gray-700 mb-2 flex items-center">
//                   <Users className="w-4 h-4 mr-1" />
//                   Job Openings
//                 </label>
//                 <p className="text-lg font-semibold text-gray-900">{career.jobDetail.jobOpenings}</p>
//               </div>
//             </div>
//           </div> */}

//           {/* Action Buttons */}
//           <div className="flex justify-end gap-5 border-t pt-6">
//             <button
//               onClick={onClose}
//               className="px-8 py-3 bg-gray-600 hover:bg-gray-700 text-white rounded-lg shadow-md font-semibold transition-colors duration-300"
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CareerViewModal;



import React from 'react';
import { X, Briefcase, Users } from "lucide-react";

const CareerViewModal = ({ career, onClose }) => {
  if (!career) return null;

  console.log("career ", career);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-gradient-to-r from-[#0bb6d9] to-[#3cd7f6] text-white p-6 flex justify-between items-center rounded-t-2xl shadow-md">
          <h2 className="text-2xl font-bold">Career Details</h2>
          <button
            onClick={onClose}
            className="hover:bg-white hover:bg-opacity-20 rounded-full p-2 transition"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="p-6 space-y-6">
          {/* Career Information */}
          <div className="bg-gray-50 rounded-lg p-6 space-y-6">
            <label className="text-lg font-semibold text-gray-800 flex items-center mb-2">
              <Briefcase className="w-5 h-5 text-[#0bb6d9] mr-2" />
              Career Information
            </label>

            {/* Company Logo */}
            {career.companyLogo && (
              <div className="flex justify-center mb-4">
                <img
                  src={career.companyLogo}
                  alt="Company Logo"
                  className="w-32 h-32 rounded-lg object-cover border-4 border-gray-200 shadow-md"
                />
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Position */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Position</label>
                <p className="text-xl font-bold text-gray-900 bg-white p-3 rounded-lg shadow-sm">
                  {career.position}
                </p>
              </div>

              {/* Job Openings */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2 flex items-center">
                  <Users className="w-4 h-4 mr-1" />
                  Job Openings
                </label>
                <p className="text-xl font-bold text-gray-900 bg-white p-3 rounded-lg shadow-sm">
                  {career.jobOpenings}
                </p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end border-t pt-6">
            <button
              onClick={onClose}
              className="px-8 py-3 bg-gray-600 hover:bg-gray-700 text-white rounded-lg shadow-md font-semibold transition-colors duration-300"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareerViewModal;